import { DefaultImageIconVariant } from 'Icons/components/DefaultImageIcon';

import { Icon } from './icon';
import { AddIconVariant } from '../components/AddIcon';
import { ApprovalIconVariant } from '../components/affiliate/ApprovalIcon';
import { ArrowBackIconVariant } from '../components/affiliate/ArrowBackIcon';
import { ArrowForwardIconVariant } from '../components/affiliate/ArrowForwardIcon';
import { CrownIconVariant } from '../components/affiliate/CrownIcon';
import { DashIconVariant } from '../components/affiliate/DashIcon';
import { DateIconVariant } from '../components/affiliate/DateIcon';
import { FeeIconVariant } from '../components/affiliate/FeeIcon';
import { HelpIconVariant } from '../components/affiliate/HelpIcon';
import { LoginIconVariant } from '../components/affiliate/LoginIcon';
import { LogoutIconVariant } from '../components/affiliate/LogoutIcon';
import { NotificationIconVariant } from '../components/affiliate/NotificationIcon';
import { RankingIconVariant } from '../components/affiliate/RankingIcon';
import { ResetIconVariant } from '../components/affiliate/ResetIcon';
import { WithDrawalIconVariant } from '../components/affiliate/WithDrawalIcon';
import { AlarmIconVariant } from '../components/AlarmIcon';
import { ArrowIconVariant } from '../components/ArrowIcon';
import { AutoPlaySetIconVariant } from '../components/AutoPlaySetIcon';
import { BadgeIconVariant } from '../components/BadgeIcon';
import { BookIconVariant } from '../components/BookIcon';
import { BookmarkIconVariant } from '../components/BookmarkIcon';
import { BubbleIconVariantEnum } from '../components/BubbleIcon';
import BubblePickIcon from '../components/BubblePickIcon';
import { BubbleSetIconVariant } from '../components/BubbleSetIcon';
import { CharacterLIconVariant } from '../components/CharacterLIcon';
import { CharacterRIconVariant } from '../components/CharacterRIcon';
import { ChatStarIconVariant } from '../components/ChatStarIcon';
import { CheckIconVariant } from '../components/CheckIcon';
import { CheckLargeIconVariant } from '../components/CheckLargeIcon';
import { CloseIconVariant } from '../components/CloseIcon';
import { CoinIconVariant } from '../components/CoinIcon';
import { CommentIconVariant } from '../components/CommentIcon';
import { CommunityEmojiIconVariant } from '../components/CommunityEmojiIcon';
import { CommunityIconVariant } from '../components/CommunityIcon';
import { DefaultUserIconVariant } from '../components/DefaultUserIcon';
import { DownloadIconVariant } from '../components/DownloadIcon';
import { DownloadTextIconVariant } from '../components/DownloadTextIcon';
import { DragIconVariant } from '../components/DragIcon';
import EditIcon from '../components/EditIcon';
import { EmailIconVariant } from '../components/EmailIcon';
import { EventLogoIconVariant } from '../components/EventLogoIcon';
import { EyeIconVariant } from '../components/EyeIcon';
import { FavoriteIconVariant } from '../components/FavoriteIcon';
import { FooterCircleIconVariant } from '../components/FooterCircleIcon';
import { GifIconVariant } from '../components/GifIcon';
import { GiftIconVariant } from '../components/GiftIcon';
import { HashIconVariant } from '../components/HashIcon';
import { HomeIconVariant } from '../components/HomeIcon';
import { LinkIconVariant } from '../components/LinkIcon';
import { LockIconVariant } from '../components/LockIcon';
import { LogoIconVariant } from '../components/LogoIcon';
import { MailIconVariant } from '../components/MailIcon';
import { MenuIconVariant } from '../components/MenuIcon';
import { ModifyIconVariant } from '../components/ModifyIcon';
import { MoreIconVariant } from '../components/MoreIcon';
import { MoveLargeIconVariant } from '../components/MoveLargeIcon';
import { MoveSmallIconVariant } from '../components/MoveSmallIcon';
import { PasswordIconVariant } from '../components/PasswordIcon';
import { PlaySetIconVariant } from '../components/PlaySetIcon';
import { ProfilePageStatisticsIconVariant } from '../components/ProfilePageStatisticsIcon';
import { PromotionBadgeIconVariant } from '../components/PromotionBadgeIcon';
import { PushNotificationIconVariant } from '../components/PushNotificationIcon';
import { RadioIconVariant } from '../components/RadioIcon';
import { RocketIconVariant } from '../components/RocketIcon';
import { SceneIconVariant } from '../components/SceneIcon';
import { SearchIconVariant } from '../components/SearchIcon';
import { SelectSmallIconVariant } from '../components/SelectSmallIcon';
import { SendEmailIconVariant } from '../components/SendEmailIcon';
import { SendIconVariant } from '../components/SendIcon';
import { SettingIconVariant } from '../components/SettingIcon';
import { ShareSocialIconVariant } from '../components/ShareIcon';
import { SignIconVariant } from '../components/SignIcon';
import { SocialIconVariant } from '../components/SocialIcon';
import { SortIconVariant } from '../components/SortIcon';
import { SoundIconVariant } from '../components/SoundIcon';
import { SquareIconVariant } from '../components/SquareIcon';
import { StarIconVariant } from '../components/StarIcon';
import { StudioToolIconVariant } from '../components/StudioToolIcon';
import { TailIconVariant } from '../components/TailIcon';
import { ThemeIconVariant } from '../components/ThemeIcon';
import { ThrillIconVariant } from '../components/ThrillIcon';
import { UniverseIconVariant } from '../components/UniverseIcon';
import { UserIconVariant } from '../components/UserIcon';

type IconListType = {
  [key in keyof typeof Icon]: string[];
};

export const IconList: IconListType = {
  BubblePick: Object.values(BubblePickIcon),
  Search: Object.values(SearchIconVariant),
  Check: Object.values(CheckIconVariant),
  Menu: Object.values(MenuIconVariant),
  Sort: Object.values(SortIconVariant),
  Arrow: Object.values(ArrowIconVariant),
  More: Object.values(MoreIconVariant),
  Text: [''],
  Plus: [''],
  Minus: [''],
  Edit: Object.values(EditIcon),
  Comment: Object.values(CommentIconVariant),
  Change: [''],
  Close: Object.values(CloseIconVariant),
  Delete: [''],
  Home: Object.values(HomeIconVariant),
  Language: [''],
  MyPage: [''],
  Remove: [''],
  Rotate: [''],
  Sign: Object.values(SignIconVariant),
  Tab: [''],
  Writing: [''],
  PlaySet: Object.values(PlaySetIconVariant),
  BubbleSet: Object.values(BubbleSetIconVariant),
  Create: [''],
  Drag: Object.values(DragIconVariant),
  Equalizer: [''],
  File: [''],
  Info: [''],
  Open: [''],
  Setting: Object.values(SettingIconVariant),
  Social: Object.values(SocialIconVariant),
  Star: Object.values(StarIconVariant),
  Mail: Object.values(MailIconVariant),
  Modify: Object.values(ModifyIconVariant),
  Radio: Object.values(RadioIconVariant),
  Favorite: Object.values(FavoriteIconVariant),
  Loading: [''],
  Warning: [''],
  UpLoadPhoto: [''],
  Narration: [''],
  Follower: [''],
  Contest: [''],
  Coin: Object.values(CoinIconVariant),
  Add: Object.values(AddIconVariant),
  PushNotification: Object.values(PushNotificationIconVariant),
  Alarm: Object.values(AlarmIconVariant),
  Community: Object.values(CommunityIconVariant),
  Camera: [''],
  Album: [''],
  ReplyLine: [''],
  ShareSocial: Object.values(ShareSocialIconVariant),
  Hash: Object.values(HashIconVariant),
  Fire: [''],
  Dot: [''],
  Reaction: [''],
  CommunityEmoji: Object.values(CommunityEmojiIconVariant),
  Vote: [''],
  Movie: [''],
  Link: Object.values(LinkIconVariant),
  Gif: Object.values(GifIconVariant),
  Thrill: Object.values(ThrillIconVariant),
  Lock: Object.values(LockIconVariant),
  Tail: Object.values(TailIconVariant),
  Reward: [''],
  // studio
  ClearRoom: [''],
  Background: [''],
  Narrative: [''],
  Status: [''],
  BgMusic: [''],
  AutoPlay: Object.values(AutoPlaySetIconVariant),
  Image: [''],
  Top: [''],
  CurrentLocation: [''],
  Bookmark: Object.values(BookmarkIconVariant),
  MoveSmall: Object.values(MoveSmallIconVariant),
  Eye: Object.values(EyeIconVariant),
  CharacterR: Object.values(CharacterRIconVariant),
  CharacterL: Object.values(CharacterLIconVariant),
  Password: Object.values(PasswordIconVariant),
  Sound: Object.values(SoundIconVariant),
  Download: Object.values(DownloadIconVariant),
  DownloadText: Object.values(DownloadTextIconVariant),
  Send: Object.values(SendIconVariant),
  MoveLarge: Object.values(MoveLargeIconVariant),
  GoTop: [''],
  Badge: Object.values(BadgeIconVariant),
  Email: Object.values(EmailIconVariant),
  SendEmail: Object.values(SendEmailIconVariant),
  Logo: Object.values(LogoIconVariant),
  CheckLarge: Object.values(CheckLargeIconVariant),
  EditProfileCamera: [''],
  SelectSmall: Object.values(SelectSmallIconVariant),
  FooterCircle: Object.values(FooterCircleIconVariant),
  StudioBackground: [''],
  NewPage: [''],
  ProfilePageStatistics: Object.values(ProfilePageStatisticsIconVariant),
  User: Object.values(UserIconVariant),
  StudioTool: Object.values(StudioToolIconVariant),
  Rocket: Object.values(RocketIconVariant),
  Gift: Object.values(GiftIconVariant),
  Book: Object.values(BookIconVariant),
  Question: [''],
  Pin: [''],
  Control: [''],
  HistoryChatBubble: [''],
  DefaultUser: Object.values(DefaultUserIconVariant),
  Document: Object.values(DownloadIconVariant),
  ScrollUp: [''],
  // 버블
  Bubble: Object.values(BubbleIconVariantEnum),
  // 챗봇
  Universe: Object.values(UniverseIconVariant),
  Scene: Object.values(SceneIconVariant),
  Dice: [''],
  Theme: Object.values(ThemeIconVariant),
  PromotionBadge: Object.values(PromotionBadgeIconVariant),
  Square: Object.values(SquareIconVariant),
  MultiImage: [''],
  ChatStar: Object.values(ChatStarIconVariant),
  ChargeStation: [''],
  Asterisk: [''],
  MultiImageUpload: [''],
  DefaultImage: Object.values(DefaultImageIconVariant),
  Memory: [''],
  // affiliate
  Approval: Object.values(ApprovalIconVariant),
  Dash: Object.values(DashIconVariant),
  Date: Object.values(DateIconVariant),
  Fee: Object.values(FeeIconVariant),
  Login: Object.values(LoginIconVariant),
  Logout: Object.values(LogoutIconVariant),
  Notification: Object.values(NotificationIconVariant),
  Reset: Object.values(ResetIconVariant),
  Crown: Object.values(CrownIconVariant),
  WithDrawal: Object.values(WithDrawalIconVariant),
  Ranking: Object.values(RankingIconVariant),
  ArrowForward: Object.values(ArrowForwardIconVariant),
  HelpIcon: Object.values(HelpIconVariant),
  ArrowBack: Object.values(ArrowBackIconVariant),
  EventLogo: Object.values(EventLogoIconVariant),
  Flip: [''],
  Support: [''],
};
